

export const config = {
    //apiUrl: 'https://localhost/api/'
    //apiUrl: 'https://localhost:44353/api/'
    // apiUrl: 'https://185.204.217.225:10439/api/'
    apiUrl: 'https://euslugi-odpady-api.um.wroc.pl/api/'
};